/**
 * Theme Config service for the global branding configuration (colors + logos)
 */

import { BaseService } from './BaseService';

export type ThemeColors = Record<string, string>;
export type ThemeImages = Record<string, string>;
export type ThemeText = Record<string, string>;

export interface ThemeConfigData {
  key?: string;
  colors?: ThemeColors;
  images?: ThemeImages;
  text?: ThemeText;
}

export interface ThemeConfigUpdate {
  colors?: ThemeColors;
  images?: ThemeImages;
  text?: ThemeText;
}

export class ThemeConfigService extends BaseService {
  /**
   * Get the active branding configuration (public endpoint)
   */
  async get() {
    return this.request<ThemeConfigData>({
      method: 'GET',
      url: this.THEME_CONFIG,
    });
  }

  /**
   * Update the branding configuration (admin only)
   * @param payload - Partial colors and/or images to persist
   */
  async update(payload: ThemeConfigUpdate) {
    return this.request<ThemeConfigData>({
      method: 'PATCH',
      url: this.THEME_CONFIG,
      data: payload,
    });
  }
}
